export default __webpack_public_path__ + "static/media/cert-general2024-hkgcsmeaa.0bff374f.jpg";